export default "__VITE_ASSET__BDWPJXU9__"